import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SingleValue } from 'react-select';
import Select from 'react-select';
import { Col, Row } from 'reactstrap';
import { ContactModel } from '../../../domain/projects/project';
import { BaseSelector } from '../../../domain/shared';
import { ContactRepository } from '../../../infrastructure/repositories/customer-contacts/contactRepository';
import { CustomerContactListSelectorDTO } from '../../../infrastructure/http/dtos/customer-contacts/customerContactListSelectorDTO';
import SimpleBar from 'simplebar-react';

interface Props {
    onChange: (selectedEmployees: ContactModel[]) => void;
    value: ContactModel[];
    name: string;
    customerId: number;
}

export const CustomerContactsAddList = ({
    onChange,
    value,
    name,
    customerId: selectedCustomerId,
}: Props) => {
    const [contacts, setContacts] = useState<BaseSelector[]>([]);
    const [contactsCopy, setContactsCopy] = useState<
        CustomerContactListSelectorDTO[]
    >([]);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if (selectedCustomerId) {
            setIsLoading(true);

            ContactRepository.GetCustomerContactListSelector(
                selectedCustomerId
            ).then((res) => {
                setContactsCopy(res);

                setIsLoading(false);
                setContacts(
                    res.map((c) => ({
                        label: `${c.firstName} ${c.middleName} ${c.lastName} ${c.surname}`,
                        value: c.id,
                    }))
                );
            });
        }
    }, [selectedCustomerId]);

    const handlerChange = (c: SingleValue<BaseSelector>) => {
        let contact = contactsCopy.find((cont) => cont.id === c?.value);
        let existContact = value.filter((ct) => ct.id === Number(c?.value));

        if (existContact.length === 0) {
            if (c && c.value !== '') {
                const newContact: ContactModel = {
                    fullName: `${contact?.firstName} ${contact?.middleName} ${contact?.lastName} ${contact?.surname}`,
                    cellphoneNumber: `${contact?.cellphoneNumber}`,
                    email: `${contact?.email}`,
                    id: Number(c?.value) ?? 0,
                    position: `${contact?.position}`,
                };

                onChange([...value, newContact]);
            }
        }
    };

    const handlerRemove = (cm: ContactModel) => {
        let contactsFilterdList = value.filter((c) => c.id !== Number(cm?.id));

        onChange(contactsFilterdList);
    };

    return (
        <div className='mt-2'>
            <div>
                <label htmlFor={name} className='form-label form-label'>
                    Contactos *
                </label>
                <Select
                    className='basic-single'
                    classNamePrefix='select'
                    isLoading={isLoading}
                    placeholder='Seleccione'
                    isSearchable
                    name='color'
                    options={contacts}
                    onChange={(c) => handlerChange(c)}
                    isClearable
                    id={name}
                />
            </div>

            {value.length > 0 && (
                <SimpleBar
                    style={{
                        maxHeight: '352px',
                        height: '250px',
                        backgroundColor: '#fff',
                    }}
                    className='py-3 mt-2'
                >
                    <div>
                        {value.length > 0 &&
                            value.map((cc, i) => (
                                <Row key={i} className='g-2 p-1'>
                                    <Col xxl={12} lg={6}>
                                        <div className='border rounded border-dashed p-1'>
                                            <div className='d-flex align-items-center'>
                                                <div className='flex-shrink-0 me-3'>
                                                    <div
                                                        key={i}
                                                        className='avatar-sm'
                                                    >
                                                        <div className='avatar-title bg-light text-primary rounded fs-24'>
                                                            <i className='ri-booklet-line'></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='flex-grow-1 overflow-hidden'>
                                                    <h5 className='fs-13 mb-0'>
                                                        <Link
                                                            to='#'
                                                            className='text-body text-truncate d-block'
                                                        >
                                                            <li key={i}>
                                                                {cc.fullName} - {' '}
                                                                {'   '} {cc.position}
                                                            </li>
                                                        </Link>
                                                    </h5>
                                                    <div className='text-muted'>
                                                        {cc.email} - {'   '}
                                                        {cc.cellphoneNumber}
                                                    </div>
                                                </div>
                                                <div className='flex-shrink-0 ms-2'>
                                                    <div className='d-flex gap-1'>
                                                        <button
                                                            onClick={() =>
                                                                handlerRemove(cc)
                                                            }
                                                            type='button'
                                                            className='btn btn-icon text-muted btn-sm fs-18'
                                                        >
                                                            <i className='ri-close-line'></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            ))}

                        {value.length === 0 && <p>No hay contactos agregados...</p>}
                    </div>
                </SimpleBar>
            )}
        </div>
    );
};
